var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _filter, _filter2, _radialGradient, _linearGradient, _radialGradient2, _linearGradient2, _radialGradient3, _linearGradient3, _radialGradient4, _radialGradient5, _linearGradient4, _radialGradient6, _radialGradient7, _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_392)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_32_392)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#200911"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#paint0_radial_32_392)",
    fillOpacity: 0.9
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_392)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85364 11.123C2.56725 15.9087 4.41143 21.8397 9.72991 24.3279C15.0484 26.8162 17.6856 25.2106 20.0751 23.4264C22.4645 21.6422 27.3806 15.3669 22.949 11.1084C18.5174 6.84987 14.7433 9.3137 9.96029 8.7368C8.11215 8.51389 5.14002 6.33723 3.85364 11.123Z",
    fill: "url(#paint1_linear_32_392)",
    fillOpacity: 0.8
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4597 18.3419C25.3691 12.9123 22.2211 5.4359 15.9185 3.09416C12.979 2.00201 13.4281 6.07485 9.77554 9.68005C6.12302 13.2853 1.44521 19.0263 6.3253 21.5198C11.2054 24.0134 14.1189 20.6353 17.4597 18.3419Z",
    fill: "url(#paint2_radial_32_392)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4597 18.3419C25.3691 12.9123 22.2211 5.4359 15.9185 3.09416C12.979 2.00201 13.4281 6.07485 9.77554 9.68005C6.12302 13.2853 1.44521 19.0263 6.3253 21.5198C11.2054 24.0134 14.1189 20.6353 17.4597 18.3419Z",
    fill: "url(#paint3_linear_32_392)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4597 18.3419C25.3691 12.9123 22.2211 5.4359 15.9185 3.09416C12.979 2.00201 13.4281 6.07485 9.77554 9.68005C6.12302 13.2853 1.44521 19.0263 6.3253 21.5198C11.2054 24.0134 14.1189 20.6353 17.4597 18.3419Z",
    fill: "url(#paint4_radial_32_392)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.4508 13.0048C6.72 8.96002 6.78822 3.08002 11.4184 3.08002C15.0738 3.08002 18.06 4.62002 19.9477 7.71213C21.8353 10.8042 25.48 11.4356 25.48 13.72C25.48 17.8645 18.1721 20.0333 13.72 19.6C9.26791 19.1667 4.18161 17.0495 5.4508 13.0048Z",
    fill: "url(#paint5_linear_32_392)",
    fillOpacity: 0.3,
    style: {
      mixBlendMode: "plus-lighter"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4508 13.0048C6.72 8.96002 6.78822 3.08002 11.4184 3.08002C15.0738 3.08002 18.06 4.62002 19.9477 7.71213C21.8353 10.8042 25.48 11.4356 25.48 13.72C25.48 17.8645 18.1721 20.0333 13.72 19.6C9.26791 19.1667 4.18161 17.0495 5.4508 13.0048Z",
    fill: "url(#paint6_radial_32_392)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6268 21.7446C15.6391 26.18 22.7791 24.5 19.6991 20.58C16.6191 16.66 16.7537 16.923 14.2747 14C14.088 16.8409 13.6145 17.3093 14.6268 21.7446Z",
    fill: "url(#paint7_radial_32_392)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6268 21.7446C15.6391 26.18 22.7791 24.5 19.6991 20.58C16.6191 16.66 16.7537 16.923 14.2747 14C14.088 16.8409 13.6145 17.3093 14.6268 21.7446Z",
    fill: "url(#paint8_linear_32_392)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint9_angular_32_392_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00661845 -0.0142007 0.0149352 0.00696079 14.14 14.98)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1036.27,
    y: -1036.27,
    width: 2072.53,
    height: 2072.53
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(250, 168, 170, 0.9687) 0deg,rgba(255, 173, 173, 1) 2.76959deg,rgba(255, 50, 5, 0) 92.9253deg,rgba(255, 240, 224, 0) 205.268deg,rgba(122, 13, 78, 0) 274.405deg,rgba(250, 168, 170, 0.9687) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M3.92 11.9C0.591219 4.47673 15.4 -1.67997 12.9866 4.56186C10.5733 10.8037 16.6992 20.9362 21.0384 13.2393C24.7466 6.66186 7.24878 19.3233 3.92 11.9Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":0.67916667461395264,\"b\":0.67916667461395264,\"a\":1.0},\"position\":0.0076932958327233791},{\"color\":{\"r\":1.0,\"g\":0.19708330929279327,\"b\":0.020833333954215050,\"a\":0.0},\"position\":0.25812581181526184},{\"color\":{\"r\":1.0,\"g\":0.94441676139831543,\"b\":0.87916666269302368,\"a\":0.0},\"position\":0.57018762826919556},{\"color\":{\"r\":0.47916665673255920,\"g\":0.053906250745058060,\"b\":0.30906248092651367,\"a\":0.0},\"position\":0.76223528385162354}],\"stopsVar\":[],\"transform\":{\"m00\":13.236895561218262,\"m01\":29.870420455932617,\"m02\":-7.4136605262756348,\"m10\":-28.401371002197266,\"m11\":13.921584129333496,\"m12\":22.219917297363281},\"opacity\":1.0,\"blendMode\":\"SCREEN\",\"visible\":true}",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter1_f_32_392)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.459 14.0548C22.3667 16.2625 15.354 15.9229 14.3277 19.1494C13.3014 22.376 5.26234 17.1116 9.19636 14.0548C13.1304 10.9981 6.28861 12.6963 14.3277 8.96021C22.3668 5.22414 16.5513 11.8472 19.459 14.0548Z",
    fill: "url(#paint10_radial_32_392)",
    fillOpacity: 0.6
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8012 18.3084C10.36 17.92 9.09998 17.22 9.60117 14.1084C10.1024 10.9969 11.7824 11.6969 13.8012 9.90844C15.82 8.11999 16.9988 9.69155 18.76 13.02C20.5212 16.3484 17.2424 18.6969 13.8012 18.3084Z",
    fill: "url(#paint11_radial_32_392)"
  })))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_32_392",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8625 0 0 0 0 0.251563 0 0 0 0 0.618125 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_32_392"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945833 0 0 0 0 0.185226 0 0 0 0 0.230862 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_32_392",
    result: "effect2_innerShadow_32_392"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.7375 0 0 0 0 0.94225 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_32_392",
    result: "effect3_innerShadow_32_392"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint9_angular_32_392_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.92 11.9C0.591219 4.47673 15.4 -1.67997 12.9866 4.56186C10.5733 10.8037 16.6992 20.9362 21.0384 13.2393C24.7466 6.66186 7.24878 19.3233 3.92 11.9Z",
    style: {
      mixBlendMode: "screen"
    }
  })), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_32_392",
    x: 4.12,
    y: 3.84003,
    width: 20.04,
    height: 20.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_32_392"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_32_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.12 1.82) rotate(63.4457) scale(13.6164 16.1527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA72FF",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344B9D",
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_392",
    x1: 5.97667,
    y1: 21.0222,
    x2: 11.5598,
    y2: 11.8741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9777C0",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95BEC",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_32_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.013 6.38776 -5.12247 11.1375 5.50179 12.9327)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1506B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BADE",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32_392",
    x1: 8.13281,
    y1: 6.8719,
    x2: 10.475,
    y2: 9.83635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C150A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0ADBC",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_32_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.36695 6.66858 -5.67024 -3.10915 14.9408 14.1492)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6CD",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32_392",
    x1: 22.1693,
    y1: 16.2158,
    x2: 24.9361,
    y2: 10.9229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE518C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665732,
    stopColor: "#EE518C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911525,
    stopColor: "#FF7DAE"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_32_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.16 13.58) rotate(30.6997) scale(5.21018 6.35831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F4791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4791",
    stopOpacity: 0
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_32_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.4 -6.58 8.43114 -1.77295 18.06 24.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E375DF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91B2"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_32_392",
    x1: 14.6388,
    y1: 15.2322,
    x2: 15.0604,
    y2: 18.0889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_32_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3277 14.0548) rotate(90) scale(5.09462 5.13132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165839,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335281,
    stopColor: "#FFD18B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF144D",
    stopOpacity: 0
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_32_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8012 14.1084) rotate(-180) scale(4.2 4.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165839,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335281,
    stopColor: "#FFD18B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF144D",
    stopOpacity: 0
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAvatar);
export default __webpack_public_path__ + "static/media/messageAvatar.4bad36bc8cbbbf1b435be717e115c0b9.svg";
export { ForwardRef as ReactComponent };